import { jsx as R } from "../../_virtual/jsx-runtime.mjs";
import t from "react";
import { horizontal as h, inline as L, vertical as S, sizeMedium as b, sizeLarge as g, sizeSmall as k, reoForm as y } from "./css/ReoForm.mjs";
import H from "../../depend/classnames/index.mjs";
import { FormContext as O } from "./context/ReoFormCompContext.mjs";
import P from "../../depend/rc-field-form/es/index.mjs";
import { useTheme as V } from "../../hook/useTheme.mjs";
import { EThemeTemplate as $ } from "../../common/type.mjs";
import q from "./hooks/useForm.mjs";
const A = ({
  className: v,
  style: F,
  form: N,
  name: m,
  layout: n,
  onFinishFailed: l,
  labelAlign: c,
  theme: T,
  size: o,
  formItemClassName: f,
  fixMarginBottom: i,
  scrollToFirstError: u,
  ..._
}, C) => {
  const d = t.useRef(null), [r] = q(N), { __INTERNAL__: s } = r;
  s.name = m;
  const E = V({ theme: T, template: $.FORM }), M = t.useMemo(() => {
    switch (n) {
      case "horizontal":
        return h;
      case "vertical":
        return S;
      case "inline":
        return L;
      default:
        return h;
    }
  }, [n]), w = t.useMemo(() => {
    switch (o) {
      case "small":
        return k;
      case "large":
        return g;
      case "medium":
      default:
        return b;
    }
  }, [o]), x = H(
    y,
    E,
    w,
    M,
    v
  ), z = t.useMemo(
    () => ({
      name: m,
      form: r,
      labelAlign: c,
      size: o,
      fixMarginBottom: i,
      formItemClassName: f,
      itemRef: s.itemRef
    }),
    [s.itemRef, i, r, f, c, m, o]
  ), j = (e, a) => {
    if (e) {
      let p = { block: "center" };
      typeof e == "object" && (p = e), r.scrollToField(a, p);
    }
  }, I = (e) => {
    if (l == null || l(e), e.errorFields.length) {
      const a = e.errorFields[0].name;
      if (u !== void 0) {
        j(u, a);
        return;
      }
    }
  };
  return t.useImperativeHandle(C, () => {
    var e;
    return {
      ...r,
      nativeElement: (e = d.current) == null ? void 0 : e.nativeElement
    };
  }), /* @__PURE__ */ R(O.Provider, { value: z, children: /* @__PURE__ */ R(
    P,
    {
      id: m,
      ..._,
      name: m,
      onFinishFailed: I,
      form: r,
      ref: d,
      className: x,
      style: F
    }
  ) });
}, Z = t.forwardRef(A);
export {
  Z as default
};
//# sourceMappingURL=ReoForm.mjs.map
